function SelectDeliveryAddress() {
  const selectDeliveryAddresses = document.querySelectorAll('.select_delivery_address');
  [].forEach.call(selectDeliveryAddresses, (selectDeliveryAddress) => {
    selectDeliveryAddress.addEventListener('click', event => {
      const httpRequest = new XMLHttpRequest();
      httpRequest.onreadystatechange = function () {
        if (this.status === 200) {
          location.reload();
        }
      };
      httpRequest.open('GET', selectDeliveryAddress.dataset.url);
      httpRequest.send();
    });
  });
}

export default SelectDeliveryAddress;
